import React, { lazy } from "react";

const SettingsPage = lazy(() => import("./SystemPage"));

const systemRoute = {
  path: "system",
  element: <SettingsPage />,
  root: true,
  permission: "ui_view_settings",
};

export default systemRoute;
